




































































































































import PagingUnit from '@/components/paging/paging.vue'; // 分页
import EditRole from '@/views/system/permission/role/unit/editRole.vue';
import RoleAssignDataPermissions from '@/views/system/permission/role/unit/roleAssignDataPermissions.vue';
import RoleAssignFunctionalPermissions from '@/views/system/permission/role/unit/roleAssignFunctionalPermissions.vue';
import RoleAssignmentUser from '@/views/system/permission/role/unit/roleAssignmentUser/roleAssignmentUser.vue';
import addRole from '@/views/system/permission/role/unit/addRole.vue';
import { Vue, Component, PropSync } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { TableStripe } from '@/mixins/tableStripe';
import { menuServe, professionServer, roleServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import treeUnit from '@/components/tree/treeUnit.vue';

@Component({
  components: {
    CollapseTransition,
    PagingUnit,
    RoleAssignFunctionalPermissions,
    EditRole,
    RoleAssignDataPermissions,
    RoleAssignmentUser,
    addRole,
    treeUnit,
  },
  mixins: [TableStripe],
})
export default class Role extends Vue {
  openFlag = true; // 控制左侧导航栏是否显示
  rowId = ''; // 传递到编辑页面和角色分配页面的 该行的id
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  editRoleFlag = 1; // 控制显示 编辑 页面
  searchFlag = false; // 控制显示 查询和隐藏查询
  searchOrgan = ''; // 搜索机构需要的数据
  total = 0; // 总共多少条数据
  // openTreeFlag = false; // 树是否打开
  obj: object = {}; // 搜索需要的对象
  // 搜索栏的数据对象
  searchFormData: object = {
    name: undefined, // 角色名称
    // spaceId: undefined, // 角色编码
    dataScopeType: undefined, // 数据权限类型
  };
  // 数据权限类型 单选按钮
  dataScopeType: Array<any> = [
    {
      index: '0',
      value: 'all',
      label: '全部数据',
    },
    {
      index: '1',
      value: 'currentSpace',
      label: '本公司数据',
    },
    {
      index: '2',
      value: 'currentDeptAndSubDept',
      label: '本部门数据',
    },
    {
      index: '3',
      value: 'custom',
      label: '自定义数据',
    },
  ];
  // 表格的表头数据
  tableHeadData: any[] = [
    { prop: 'name', label: '角色名称' },
    // { prop: 'spaceId', label: '角色编码' },
    // { prop: 'spaceCode', label: '排序号' },
    // { prop: 'organ', label: '系统角色' },
    { prop: 'dataScopeType', label: '数据权限类型' },
    // { prop: 'email', label: '数据范围' },
    // { prop: 'systemRole', label: '业务范围' },
    { prop: 'updateTime', label: '更新时间' },
    { prop: 'description', label: '描述' },
    // { prop: 'state', label: '状态' },
    { prop: '', label: '操作' },
  ];
  // 表格的数据对象
  tableData: Array<any> = [];

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮会触发事件，用于显示和隐藏搜索栏
   * @param1 暂无
   * @returns 暂无
   */
  hideSearch(): void {
    this.searchFlag = !this.searchFlag;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 创建钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 调用获取全部数据方法
    this.getRoleDataList();
  }

  getNodeIds(data: any) {
    // this.getAllData({});
    this.getRoleDataList();
  }

  showTree(flag: boolean) {
    this.openFlag = flag;
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  private getRoleDataList(): void {
    // 发起接口请求，获取分页数据
    roleServe
      .getRoleDataList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        // name: this.searchFormData.name ? this.searchFormData.name : null,
      })
      .then((res: any) => {
        // console.log('resData', res); // 全部数据
        // console.log(res.data.records[0].updateTime)
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  searchTableData(): void {
    // alert('查询');
    (this.obj as any).name = (this.searchFormData as any).name; // 角色名称
    // (this.obj as any).spaceId = (this.searchFormData as any).spaceId; // 角色编码
    (this.obj as any).dataScopeType = (this.searchFormData as any).dataScopeType; // 数据权限类型
    (this.queryDataForm as any).pageNo = 1;
    roleServe
      .getRoleDataList({
        ...this.searchFormData,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        // console.log('res', res);
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.$message.success('查询成功!');
      })
      .catch((error: any) => {
        this.$message.error('查询失败，请重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  resetSearch() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    (this.queryDataForm as any).pageNo = 1;
    this.obj = {};
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 停用用户
   * @param1 暂无
   * @returns 暂无
   */
  // stopUser(): void {
  //   this.$confirm('确认要停用该角色吗？', '信息', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning',
  //     customClass: 'box--msg',
  //   })
  //     .then(() => {
  //       this.$message({
  //         type: 'success',
  //         message: '停用成功!',
  //       });
  //     })
  //     .catch(() => {
  //       this.$message({
  //         type: 'info',
  //         message: '已取消停用',
  //       });
  //     });
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除用户
   * @param1 暂无
   * @returns 暂无
   */
  deleteUser(id: number): void {
    this.$confirm('确认要删除该岗位吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        if (this.total % (this.queryDataForm as any).pageSize === 1 && (this.queryDataForm as any).pageNo !== 1) {
          (this.queryDataForm as any).pageNo--;
        }
        roleServe
          .deleteRoleData({ idList: id })
          .then((res: any) => {
            this.getRoleDataList(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 状态的计算属性，如果状态是 1 则是正常 ,2 停用
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  // get setUserState(): object {
  //   return (state: number): string => {
  //     if (state == 1) {
  //       return '正常';
  //     } else if (state == 2) {
  //       return '停用';
  //     } else {
  //       return '冻结';
  //     }
  //   };
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc 判断数据权限类型的 all -> 全部数据，currentSpace -> 本公司数据 等
   * @param1 传入用户的 dataScopeType 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  get switchDataScopeType(): object {
    return (dataScopeType: string): string => {
      if (dataScopeType == 'all') {
        return '全部数据';
      } else if (dataScopeType == 'currentSpace') {
        return '本公司数据';
      } else if (dataScopeType == 'currentDeptAndSubDept') {
        return '本部门数据';
      } else {
        return '自定义数据';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  // get setStateColor(): object {
  //   return (state: number): string => {
  //     if (state == 1) {
  //       return 'tag-green';
  //     } else if (state == 2) {
  //       return 'tag-red';
  //     } else {
  //       return 'tag-orange';
  //     }
  //   };
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击图标进入机构管理组件
   * @param1 暂无
   * @returns 暂无
   */
  enterOrganManage(): void {
    window.alert('进入机构管理');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 关闭 dialog 弹框,清空 搜索 栏的数据
   * @param1 暂无
   * @returns 暂无
   */
  closeDialog(): void {
    this.searchOrgan = '';
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性，判断table的该项是否添加 fixed
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  get setFixed() {
    return (label: string) => {
      if (label === '角色名称') {
        return true;
      } else if (label === '操作') {
        return 'right';
      } else {
        return false;
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 打开编辑页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  showEditRole(rowId: string) {
    this.rowId = rowId; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  closeEditRole(): void {
    this.editRoleFlag = 1;
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 打开 角色分配数据权限 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  showRoleAssignDataPermission(rowId: string): void {
    this.rowId = rowId; // 将该行 id 传递到 角色分配数据权限 页面
    this.editRoleFlag = 3;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 关闭 角色分配数据权限 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  closeRoleAssignDataPermission(): void {
    this.editRoleFlag = 1;
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 打开 角色分配功能权限 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  showRoleAssignFuncacionalPermissions(rowId: string) {
    this.rowId = rowId; // 将该行 id 传递到角色分配功能权限页面
    this.editRoleFlag = 4;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 关闭 角色分配数据权限 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  closeRoleAssignFuncacionalPermissions(): void {
    this.editRoleFlag = 1;
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 打开 角色分配用户 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  showRoleAssignmentUser(): void {
    this.editRoleFlag = 5;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 关闭 角色分配用户 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  closeRoleAssignmentUser(): void {
    this.editRoleFlag = 1;
    this.getRoleDataList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 打开 新增角色 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  showAddRole(): void {
    this.editRoleFlag = 6;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 用于点击角色名称一栏里面内容 实现 关闭 新增角色 页面
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  closeAddRole(): void {
    this.editRoleFlag = 1;
    this.getRoleDataList();
  }
}
